module.exports = __webpack_public_path__ + "img/user-round-search.03a0d339.svg";